/**
 *
 * FactoidCard
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import WidgetBox from 'components/WidgetBox';
import ClassNames from 'classnames';
import Mixpanel from 'utils/mixpanelService';

const styles = theme => ({
  headerText: {
    marginBottom: 10,
  },
  disabledLink: {
    pointerEvents: 'none',
  },
  btnLink: {
    color: theme.palette.primary.secondary,
    width: '100%',
    padding: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 20,
    textDecoration: 'none',
    fontSize: 14,
  },
});

class FactoidCard extends React.PureComponent {
  redirect = () => {
    const { topicName, data } = this.props;
    Mixpanel.track('Topic Center Factoid - Clicked', {
      topic: topicName,
      entryId: data.sys.id,
      factoidName: _get(data, 'fields.organization.0.fields.name'),
    });
  };

  render() {
    const { classes, data } = this.props;
    if (_isEmpty(_get(data, 'fields'))) return null;
    const { factoidTitle, article, organization } = data.fields;
    return (
      <>
        <Grid item xs={12}>
          <Typography
            className={classes.headerText}
            variant="h5"
            color="textPrimary"
          >
            {factoidTitle}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <WidgetBox>
            <Typography variant="overline" component="p">
              {article}
            </Typography>
            {!_isEmpty(_get(organization, '0.fields.slug')) && (
              <Link
                to={
                  _get(organization, '0.fields.reviewStatus') === 'Accepted' &&
                  `/organizations/${_get(organization, '0.fields.slug')}`
                }
                className={ClassNames(
                  classes.btnLink,
                  _get(organization, '0.fields.reviewStatus') !== 'Accepted' &&
                    classes.disabledLink,
                )}
                onClick={() => this.redirect()}
              >
                {_get(organization, '0.fields.name')}
              </Link>
            )}
          </WidgetBox>
        </Grid>
      </>
    );
  }
}

FactoidCard.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  topicName: PropTypes.string,
};

export default withStyles(styles)(FactoidCard);
